import { Form, Select } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { FC, ReactNode } from 'react'
import { useGetUsersQuery } from '../../../store/api/users-api'
import { Rule } from 'antd/es/form'
import { requiredRules } from '../../../constants/forms/validation/rules'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import UserOptionLabel from './user-option-label'

const ACTIVE_TASK_STATUSES = ['Новая', 'В работе'] as const

interface UserSelectOption {
    value: string
    label: string
    activeTasksCount?: number
}

interface UserProps {
    name: NamePath
    label?: ReactNode
    rules?: Rule[]
    noStyle?: boolean
    placeholder?: string
    positions?: string[]
    showActiveTaskCount?: boolean
}

const User: FC<UserProps> = ({
    name,
    label,
    rules = requiredRules,
    noStyle,
    placeholder,
    positions,
    showActiveTaskCount = false,
}) => {
    const queryParams: EndpointQueryParameters = {
        filters:
            positions && positions.length > 0
                ? {
                      user_position: {
                          name: {
                              $in: positions,
                          },
                      },
                  }
                : undefined,
        populate: showActiveTaskCount
            ? {
                  tasks: {
                      fields: ['id'],
                      filters: {
                          taskStatus: {
                              $in: [...ACTIVE_TASK_STATUSES],
                          },
                      },
                  },
              }
            : undefined,
    }

    const { data: users } = useGetUsersQuery(queryParams)

    const options: UserSelectOption[] | undefined = showActiveTaskCount
        ? [...(users ?? [])]
              .sort((a, b) => {
                  const aCount = a.tasks?.length ?? 0
                  const bCount = b.tasks?.length ?? 0
                  if (aCount !== bCount) {
                      return aCount - bCount
                  }
                  return a.username.localeCompare(b.username)
              })
              .map(item => ({
                  value: item.documentId,
                  label: item.username,
                  activeTasksCount: item.tasks?.length ?? 0,
              }))
        : users?.map(item => ({ value: item.documentId, label: item.username }))

    return (
        <Form.Item name={name} label={label} rules={rules} noStyle={noStyle}>
            <Select<string, UserSelectOption>
                style={{ width: '100%' }}
                options={options}
                allowClear
                placeholder={placeholder}
                showSearch
                filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase())
                }
                optionRender={
                    showActiveTaskCount
                        ? option => (
                              <UserOptionLabel
                                  username={String(option.data.label ?? '')}
                                  activeTasksCount={option.data.activeTasksCount ?? 0}
                              />
                          )
                        : undefined
                }
            />
        </Form.Item>
    )
}

export default User
